import React, { useRef, useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import { DetailForm } from './detail-form';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import toast from 'react-hot-toast';
import useForms from 'src/api/cars/vm-form';
import { getVehicle } from 'src/utils/storage-data';
import PageSection from 'src/layouts/page-section';

const apiEndpoint = {
  partner: 'api/partner/list/car',
};

// Handle response when success
function handleReponseSuccess(msg) {
  toast.success(msg, { duration: 3000 });
}
// Handle response when error
function handleReponseError(msg) {
  toast.error(`Lỗi xảy ra ${msg}`, { duration: 5000 });
}

const Page = ({ onNavigate, item }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const { updateItem, deleteItem } = useForms();

  const [data, setData] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      const jsonData = await getVehicle();
      setData(jsonData);
    };

    fetchData();
  }, []);

  // Update item
  const apiUpdate = async (values) => {
    await updateItem(
      values,
      (result) => {
        handleReponseSuccess(`Sửa thành công (${result})`);
      },
      (error) => {
        handleReponseError(`khi sửa (${error})`);
      },
    );
  };

  // Update item
  const apiDelete = async (values) => {
    await deleteItem(
      values,
      (result) => {
        handleReponseSuccess(`Đã xóa (${result})`);
      },
      (error) => {
        handleReponseError(`khi xóa (${error})`);
      },
    );
  };

  return (
    <PageSection title="Car" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.carManagement)}
        />
        <Stack spacing={1}>
          <DetailForm
            item={item}
            brandOptions={data.brandName}
            carOptions={data.carName}
            gearOptions={data.transmission}
            apiEndpoint={apiEndpoint}
            apiUpdate={apiUpdate}
            apiDelete={apiDelete}
          />
        </Stack>
      </Stack>
    </PageSection>
  );
};

export default Page;
